import { openFipMigrationModal, ModalType } from '@fiverr-private/pro_migration';
import {
    BUSINESS_TRIGGER_CTA,
    CtaData,
    buildRedirectQueryParameters,
} from '@fiverr-private/business_success_sign_modal';
import { getContext } from '@fiverr-private/fiverr_context';
import { FLOW_CONTEXT_TYPES } from '../../components/shared/constants';
import { PAGE_NAME } from '../events';

const MAP_FLOW_CONTEXT: Partial<Record<FLOW_CONTEXT_TYPES, BUSINESS_TRIGGER_CTA>> = {
    purchase: BUSINESS_TRIGGER_CTA.PURCHASE,
    contact: BUSINESS_TRIGGER_CTA.CONTACT,
    request_a_quote: BUSINESS_TRIGGER_CTA.REQUEST_QUOTE,
};

const prepareRedirectCtaData = (trigger: FLOW_CONTEXT_TYPES, triggerSource?: string): CtaData | undefined => {
    const cta = MAP_FLOW_CONTEXT[trigger];
    return cta ? { type: cta, source: triggerSource } : undefined;
};

export const triggerFibMigrationPopup = ({
    trigger,
    triggerSource,
    flowCallback,
}: {
    trigger: FLOW_CONTEXT_TYPES;
    triggerSource?: string;
    sellerDisplayName: string;
    flowCallback?: () => void;
}) => {
    const ctaData = prepareRedirectCtaData(trigger, triggerSource);

    openFipMigrationModal({
        variant: ModalType.SeamlessUpgradeToPro,
        payload: {
            source: `${PAGE_NAME}.${trigger}`,
            biEnrichment: {
                pageElementName: PAGE_NAME,
                trigger,
            },
            onSuccess: () => {
                flowCallback?.();

                const url = buildRedirectQueryParameters({
                    redirectUrl: getContext().url,
                    source: `${PAGE_NAME}.${trigger}`,
                    type: BUSINESS_TRIGGER_CTA.DEFAULT,
                    ctaData,
                });

                window.location.replace(url);
            },
        },
        callbackWhenNotMounted: flowCallback,
    });
};
